
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/avatar-group",
      function () {
        return require("private-next-pages/joy-ui/api/avatar-group.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/avatar-group"])
      });
    }
  